import { CommonTranslationKeys, DocumentationTranslationKeys } from 'intl/keys';
import type { TranslationKey } from 'intl/types/translationKey';
import { LevelMapWarning } from 'shared/domain/documentation/levelMap';

const LEVEL_MAP_WARNING_LABEL_KEYS: Record<LevelMapWarning, TranslationKey> = {
  [LevelMapWarning.notSuitable]: DocumentationTranslationKeys.mapInvalidFile,
  [LevelMapWarning.noCurrentVersion]: DocumentationTranslationKeys.mapNoCurrentVersion,
  [LevelMapWarning.withdrawn]: DocumentationTranslationKeys.mapVersionWithdrawn,
  [LevelMapWarning.documentationWithdrawn]: DocumentationTranslationKeys.mapDocumentationWithdrawn,
  [LevelMapWarning.unavailable]: CommonTranslationKeys.noMapAvailable,
};

/** What the user is told about a map that cannot be shown as it is (PT-7117). */
export function levelMapWarningLabelKey(warning: LevelMapWarning): TranslationKey {
  return LEVEL_MAP_WARNING_LABEL_KEYS[warning];
}
